import { render } from "./barred-users.vue?vue&type=template&id=5e040e6e"
import script from "./barred-users.vue?vue&type=script&lang=js"
export * from "./barred-users.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__